export enum ActivityType {
  EventCreated = 10,
  EventRescheduled = 11,
  EventCanceled = 12,
  EventRequested = 20,
  EventRequestAccepted = 21,
  EventRequestDeclined = 22,
  IntegrationCalendarEvent = 21, // Deprecated
  Task = 20, // Deprecated
  Note = 30, // Deprecated
  Page = 31, // Deprecated
  Answer = 40, // Deprecated
  Kudos = 41, // Deprecated
  Suggestion = 42, // Deprecated
}
